import { useContext, useEffect, useState } from 'react';
import ivclass from '@invideoio/web-shared/Modules/IVClass';

import { useRouter } from 'next/router';

import { StateContext } from '@store/store';
import AppLayout from '@layouts/AppLayout';

import { fetchTotalCategoriesCount } from '@lib/API/categoryAPI';
import { generateBreadcrumbsFromUrl } from '@utils/common.utils';
import Breadcrumb from '@components/breadcrumbs';
import HeaderWithCTA from '@components/header-with-cta';
import PillarPageHeader from '@components/PillarPageHeader';
import CategoryPaginatedList from '@components/category-paginated-list';
import PillarPageSubHeader from '@components/PillarPageHeader/PillarPageSubHeader';
import BlogSEO from '@components/SEO/BlogSEO';
import useBlogAppLoad from '@hooks/useBlogAppLoad';
import useTranslation from 'next-translate/useTranslation';

function Categories() {
  const globalState = useContext(StateContext);
  const { platform, browser } = globalState;
  const { pathname } = useRouter();

  const [totalNoOfCategories, setTotalNoOfCategories] = useState<number>(0);

  const { lang } = useTranslation();

  useBlogAppLoad({ platform });

  useEffect(() => {
    async function getCategoriesCount() {
      const total = await fetchTotalCategoriesCount(lang);
      if (total) {
        setTotalNoOfCategories(total);
      }
    }
    getCategoriesCount();
  }, []);

  return (
    <AppLayout platform={platform}>
      <BlogSEO
        seo={{
          Title: 'Top Categories | InVideo Blog',
          CanonicalURL: 'https://invideo.io/blog/category/',
          id: 0,
          Hreflang: [],
          Keywords: '',
          Meta: [],
          RobotFollow: null,
          RobotIndex: null,
          Description:
            'InVideo is an online video creator for content and marketing videos. Read our blogs tolearn everything about creating professional quality videos.',
        }}
        url="/blog/category/"
      />
      <HeaderWithCTA />
      <PillarPageHeader title={'Popular categories'} />

      <section className={ivclass('iv-bg-black-4')}>
        <div className={ivclass('iv-container iv-mx-auto')}>
          <div className={ivclass('iv-grid iv-grid-cols-12')}>
            <div
              className={ivclass(
                'iv-col-span-12',
                'iv-mx-100 lg:iv-mx-75 md:iv-mx-25 sm:iv-mx-20',
                'iv-mt-[72px] lg:iv-mt-[70px] md:iv-mt-[53px] sm:iv-mt-[42px]',
              )}
            >
              <div
                className={ivclass(
                  'iv-mb-[28px] ',
                  'iv-pl-[39px] lg:iv-pl-[35px] md:iv-pl-[36px] sm:iv-pl-25',
                  'md:iv-mb-10 sm:iv-mb-3',
                )}
              >
                <Breadcrumb
                  breadcrumbItems={generateBreadcrumbsFromUrl(pathname)}
                />
              </div>
              <div
                className={ivclass(
                  'iv-mb-[65px] ',
                  'iv-pl-40 lg:iv-pl-[35px] md:iv-pl-[37px] sm:iv-pl-25',
                  'md:iv-mb-[33px] sm:iv-mb-[13px]',
                )}
              >
                <PillarPageSubHeader
                  count={totalNoOfCategories}
                  title={'categories'}
                />
              </div>

              <CategoryPaginatedList
                browser={browser}
                platform={platform}
                totalCategories={totalNoOfCategories}
              />
            </div>
          </div>
        </div>
      </section>
    </AppLayout>
  );
}

export default Categories;
